export default {
  common: {
    restart: 'Restart',
    clearAll: 'Clear All'
  },
  error: {
    restart: "Looks you're trying to get into something we are still developing...",
    tryAgainMsg: 'Please try again, if this error continue, contact Metrica Sports support team'
  },
  verifyEmail: {
    successfully: 'Email verified successfully',
    readyToLogin: 'You are ready to login into Play',
    unsuccessfully: 'Error verifying email, invalid token',
    generateLink: 'Generate a new link by logging into Play'
  },
  download: {
    bodyTitle: 'Download',
    bodyTitleFromTrial: 'Successful Registration',
    bodyTitleFromAcceptInvitation: 'We are switching your account',
    bodyTitleFromDeclineInvitation: 'Invitation Declined',
    bodyText: 'Click a Download link below to download %{products}',
    bothProducts: 'PlayBase and/or Nexus',
    bodyTextFromTrial:
      'Welcome to Your Trial Setup! Check your registered email for a verification link (check spam folder).',
    bodyTextFromAcceptInvitation:
      'The process will take some time. In the meantime, you can continue to use Metrica Sports as usual.',
    bodyTextFromDeclineInvitation:
      'You have declined the invitation! Click a Download link below to download %{products}',
    thanks:
      'Thank you for registering with Metrica Sports! To get started with your trial, download %{products}.',
    play2: {
      description:
        'Metrica PlayBase is an intuitive analysis tool designed for amateur and prosumer coaches, small clubs, and independent analysts. It simplifies the process of performance evaluation, making it accessible for everyone.'
    },
    play3: {
      description:
        'Metrica Nexus is tailored for elite analysts and coaches seeking comprehensive performance insights. With advanced tools at your fingertips, you can enhance team strategies and drive success.'
    }
  }
}
